export const SET_HRES6KE_INDEX_DISP = 'SET_HRES6KE_INDEX_DISP'
export const GET_HRES6KE_INDEX_DISP = 'GET_HRES6KE_INDEX_DISP'
export const SET_HRES6KE_DETAIL_DISP = 'SET_HRES6KE_DETAIL_DISP'
export const GET_HRES6KE_DETAIL_DISP = 'GET_HRES6KE_DETAIL_DISP'
export const SET_HRES6KE_COLUMNS = 'SET_HRES6KE_COLUMNS'
export const GET_HRES6KE_COLUMNS = 'GET_HRES6KE_COLUMNS'
export const SET_HRES6KE_LABELS = 'SET_HRES6KE_LABELS'
export const GET_HRES6KE_LABELS = 'GET_HRES6KE_LABELS'
export const RECEIVED_HRES6KE_COLUMNS_LABELS = 'RECEIVED_HRES6KE_COLUMNS_LABELS'
export const SET_HRES6KE_INDEX = 'SET_HRES6KE_INDEX'
export const GET_HRES6KE_INDEX = 'GET_HRES6KE_INDEX'
export const SET_HRES6KE_INDEX_SELECTED = 'SET_HRES6KE_INDEX_SELECTED'
export const GET_HRES6KE_INDEX_SELECTED = 'GET_HRES6KE_INDEX_SELECTED'
export const RECEIVED_HRES6KE_INDEX = 'RECEIVED_HRES6KE_INDEX'
export const RECEIVED_HRES6KE_CREATE = 'RECEIVED_HRES6KE_CREATE'
export const SET_HRES6KE_CURRENT_NUMSEQ = 'SET_HRES6KE_CURRENT_NUMSEQ'
export const GET_HRES6KE_CURRENT_NUMSEQ = 'GET_HRES6KE_CURRENT_NUMSEQ'
export const RECEIVED_HRES6KE_CURRENT_NUMSEQ = 'RECEIVED_HRES6KE_CURRENT_NUMSEQ'
export const SET_HRES6KE_DETAIL = 'SET_HRES6KE_DETAIL'
export const GET_HRES6KE_DETAIL = 'GET_HRES6KE_DETAIL'
export const RECEIVED_HRES6KE_DETAIL = 'RECEIVED_HRES6KE_DETAIL'
export const SET_HRES6KE_DROPDOWNS = 'SET_HRES6KE_DROPDOWNS'
export const GET_HRES6KE_DROPDOWNS = 'GET_HRES6KE_DROPDOWNS'
export const RECEIVED_HRES6KE_DROPDOWNS = 'RECEIVED_HRES6KE_DROPDOWNS'
export const TOGGLE_HRES6KE_PAGE = 'TOGGLE_HRES6KE_PAGE'
export const POST_HRES6KE_SAVE = 'POST_HRES6KE_SAVE'
export const POST_HRES6KE_CANCEL = 'POST_HRES6KE_CANCEL'



// WEBPACK FOOTER //
// ./src/store/modules/hres6ke/mutation-types.js